export default __webpack_public_path__ + "static/media/maintenance.6c324598.svg";